import EndPoint from 'Api/EndPoint';
import Client from 'Api/Client';

const endpoint = `${EndPoint.HostV2}/${EndPoint.CustomerSupportAutoReply}`;

export async function getCustomerSupportAutoReplyConfig() {
  return await Client.get(`${endpoint}/config`, {}, true);
}
